import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '931401796468747';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Prevent double-initialization
    if (window.fbq) return;
    const f: any = window;
    const b = document;
    const n = 'script';
    f.fbq = function () {
      // eslint-disable-next-line prefer-rest-params
      f.fbq.callMethod ? f.fbq.callMethod.apply(f.fbq, arguments) : f.fbq.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = f.fbq;
    f.fbq.push = f.fbq;
    f.fbq.loaded = true;
    f.fbq.version = '2.0';
    f.fbq.queue = [];
    const e = b.createElement(n) as HTMLScriptElement;
    e.async = true;
    e.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const t = b.getElementsByTagName(n)[0];
    if (t && t.parentNode) {
      t.parentNode.insertBefore(e, t);
    } else {
      b.head.appendChild(e);
    }
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return null;
}